/* ---------- Hero: what the case studies show ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-16);
  background: var(--surface-alt);
}
.heroTitle {
  max-width: 18ch;
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  max-width: 40rem;
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}

/* ---------- The studies: one row each, as many as there are ---------- */
.list {
  display: grid;
}
.list > li + li .study {
  border-top: 1px solid var(--border-strong);
}
/* The whole row is the title's link target. */
.study {
  position: relative;
  display: grid;
  gap: var(--sp-6);
  padding-block: var(--sp-10);
}
.list > li:first-child .study {
  padding-top: var(--sp-4);
}
.image {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  transition: transform var(--dur) var(--ease);
}
.study:hover .image {
  transform: translateY(-3px);
}
.body {
  align-self: center;
}
.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-2) var(--sp-4);
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.product {
  padding: 2px var(--sp-3);
  border: 1px solid var(--border-strong);
  border-radius: 999px;
  font-weight: 600;
  color: var(--text-strong);
}
.title {
  margin-top: var(--sp-3);
  font-size: clamp(1.625rem, 1rem + 1.3vw, 2.25rem);
  line-height: var(--lh-tight);
  letter-spacing: var(--tracking-heading);
  text-wrap: balance;
}
.link {
  color: var(--text-strong);
  text-decoration: none;
}
.link::after {
  content: "";
  position: absolute;
  inset: 0;
}
.study:hover .link {
  color: var(--accent-text);
}
/* The result the study is about: its figure large, the rest of the sentence after it. */
.result {
  max-width: 36rem;
  margin: var(--sp-5) 0 0;
  padding-left: var(--sp-4);
  border-left: 3px solid var(--accent);
  font-size: var(--fs-md);
  color: var(--text-strong);
}
.result strong {
  display: block;
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 1.2rem + 1.4vw, 2.5rem);
  line-height: 1.1;
  letter-spacing: var(--tracking-heading);
  color: var(--accent-text);
}
.summary {
  max-width: 36rem;
  margin: var(--sp-4) 0 0;
  color: var(--text);
}
.more {
  margin: var(--sp-5) 0 0;
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.empty {
  color: var(--text-muted);
}
@media (min-width: 48rem) {
  .study {
    grid-template-columns: minmax(0, 5fr) minmax(0, 6fr);
    gap: var(--sp-12);
  }
}
@media (prefers-reduced-motion: reduce) {
  .image {
    transition: none;
  }
  .study:hover .image {
    transform: none;
  }
}
